import Axios from "axios";
import {
  SET_HRM_CLAIM_TYPE_LIST,
  UNSET_HRM_CLAIM_TYPE_LIST,
} from "@/store/mutation-types";
import { getClaimTypeList } from "@/store/api";

const state = {
  getHrmClaimTypeList: [],
};

const getters = {
  getHrmClaimTypeList(state) {
    return state.getHrmClaimTypeList;
  },
};

const mutations = {
  [SET_HRM_CLAIM_TYPE_LIST](state, data) {
    state.getHrmClaimTypeList = data || [];
  },
  [UNSET_HRM_CLAIM_TYPE_LIST](state) {
    state.getHrmClaimTypeList = [];
  },
};

const actions = {
  getClaimTypeList({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(getClaimTypeList)
        .then(function (response) {
          commit("SET_HRM_CLAIM_TYPE_LIST", response.data.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_HRM_CLAIM_TYPE_LIST");
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
